export const DiscontinuedBadgeComponent = {
  bindings: {
    status: '='
  },
  controller: class {
    status;
  },
  template: `<span class="badge discontinued-product-badge" ng-if="$ctrl.status === 'Discontinued'">D/C</span>`
};
